import { LOCALES } from './../constants.js';

export default {
    [LOCALES.FRENCH]: {
        'hello': 'Bonjour', 
        'generalInformation':'INFORMATION GENERAL',
        'technicalInformation':'INFORMATION TECHNIQUE',
        'serviceType': 'TYPE DE SERVICE:',
        'encryption': 'Encryptage :',
        'language':'Langue :',
        'genre':'Thème :',
        'resolution':'Résolution :',
        'satellite':'Satellite :',
        'orbitalPosition':'Position orbitale :',
        'beam':'Beam :',
        'frequency':'Fréquence :',
        'polarization':'Polarisation :',
        'symbolRate':'Taux de symbole :',
        'coverage':'COUVERTURE',
        'antennaSize':"TAILLE D'ANTENNE",
        'satelliteDetails':'Détails du satellite',
        'tableOfDbw':'TABLEAU DES DBW',
        'tableOfDbwAntennaSize':"ET TAILLE D'ANTENNE",
        'satelliteFilter':'FILTRE SATELLITE:',
        'contentFilter':'FILTRE DE CONTENU:',
        'channelResolution':'RESOLUTION DES CHAINES:',
        'channelEncryption':'ENCRYPTAGE DES CHAINES:',
        'allSatellites':'Tous les satellites',
        'allOrbitalPositions':'Toutes les positions orbitales',
        'allLanguages':'Toutes les langues',
        'allGenres':'Tous les thèmes',
        'search':'Rechercher',
        'homeTitle1': 'Rechercher une chaîne de télévision',
        'homeTitle2': 'diffusée par Eutelsat',
        'formRechercheFreeToAir': 'En clair',
        'formRechercheEncoded': 'Encrypté',
        'resetListSatellites': 'Réinitialiser',
        'tableOfDbwTitleLine1': 'Pour calculer la taille de votre antenne ',
        'tableOfDbwTitleLine2': 'il faut vous référer à la puissance en dBW ',
        'tableOfDbwTitleLine3': 'du faisceau de réception du satellite.',
        'footerSatellites': 'Satellites',
        'footerReserveCapacity' : 'Réservez capacité',
        'footerPrivacy' : 'Confidentialité',
        'footerCookiePolicy' : 'Politique cookies',
        'footerCookieManagement' : 'Paramétrage des cookies',
        'footerLegal' : 'Mentions légales',
        'menuButtonContactUs' : 'Contactez-nous'
    }
}